import {
  ButtonType,
  CovButton,
  CovDialog,
  CovIcon,
  IconName,
} from "@cx-component-library/react-components";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface DiscardProgressDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * "Current Progress Will Be Lost" confirmation dialog shared by every flow that
 * can discard in-progress upload-flow state (Discovery category switching,
 * app-wide navigation guarding, and the Upload & Match results view).
 */
export const DiscardProgressDialog = ({
  open,
  onCancel,
  onConfirm,
}: DiscardProgressDialogProps) => {
  const { t } = useTranslation();

  return (
    <CovDialog
      open={open}
      onClose={onCancel}
      hasCloseButton={true}
      isBannerLight={true}
      bannerContent={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "var(--spacing14)",
          }}
        >
          <CovIcon
            iconName={IconName.WARNING_AMBER}
            iconColor="var(--global-orange-orange-6)"
            iconSize="x2"
          />
        </Box>
      }
      title={t("ldp_discard_dialog_title")}
      subTitle={t("ldp_discard_dialog_subtitle")}
      actions={
        <>
          <CovButton
            buttonType={ButtonType.SECONDARY_OUTLINE}
            onClick={onConfirm}
          >
            {t("ldp_discard_dialog_confirm")}
          </CovButton>
          <CovButton buttonType={ButtonType.PRIMARY} onClick={onCancel}>
            {t("ldp_discard_dialog_cancel")}
          </CovButton>
        </>
      }
    />
  );
};
